<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>称重系统设置</span>
                </div>
            </div>
            <div class="btn_box">
                <div class="button button2 add" @click="addDislogShow" v-if="roleCheck('106-104-101-102')">
                    <i class="el-icon-plus"></i>
                    <span>新建</span>
                </div>
            </div>
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                <el-table-column prop="product_name" label="产品名称"></el-table-column>
                <el-table-column prop="product_code" label="产品代码"></el-table-column>
                <el-table-column label="重量范围(kg)">
                    <template slot-scope="scope" >
                        <span>{{ scope.row.min_weight + ' - ' + scope.row.max_weight }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="产品代码在SN码位置">
                    <template slot-scope="scope" >
                        <span>{{ scope.row.sn_start_local + ' - ' + scope.row.sn_end_local }}</span>
                    </template>
                </el-table-column>
                
                <el-table-column label="操作">
                    <template slot-scope="scope" >
                        <div>
                            <div class="button text" @click="updateDislogShow(scope.row)" v-if="roleCheck('106-104-101-102')">编辑</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination> -->
            <Gh-Dialog ref="weightSetting" size="big" :title="dialog.title" @dialogBack="settingConfirm">
                <template v-slot:content>
                    <el-form label-width="200px" :model="actData" ref="addProductRule" :rules="formRule">
                        <el-form-item label="产品名称" prop="product_name">
                            <el-input v-model="actData.product_name" placeholder="请输入产品名称"></el-input>
                        </el-form-item>
                        <el-form-item label="产品代码" prop="product_code">
                            <el-input v-model="actData.product_code" placeholder="请输入产品代码"></el-input>
                        </el-form-item>
                        <el-form-item label="最小重量（kg）" prop="min_weight">
                            <el-input v-model="actData.min_weight" placeholder="请输入产品最小重量"></el-input>
                        </el-form-item>
                        <el-form-item label="最大重量（kg）" prop="max_weight">
                            <el-input v-model="actData.max_weight" placeholder="请输入产品最大重量"></el-input>
                        </el-form-item>
                        <el-form-item label="产品代码位于SN起始位置" prop="sn_start_local">
                            <el-input v-model="actData.sn_start_local" placeholder="请输入产品代码位于SN起始位置"></el-input>
                        </el-form-item>
                        <el-form-item label="产品代码位于SN结束位置" prop="sn_end_local">
                            <el-input v-model="actData.sn_end_local" placeholder="请输入产品代码位于SN结束位置"></el-input>
                        </el-form-item>
                        <p class="tip">产品代码位于SN位置：以SN号为PB005JPB23260001举例，产品代码为005，产品代码位于SN起始位置为3，产品代码位于SN结束位置为5。</p>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'weight-setting',
    data() {
        return {
            searchData: {
            },
            dialog: {},
            actData: {},
            listData: [],
            formRule: {
                product_name: [this.requiredRule('请输入产品名称')],
                product_code: [this.requiredRule('请输入产品代码')],
                min_weight: [this.requiredRule('请输入产品最小重量')],
                max_weight: [this.requiredRule('请输入产品最大重量')],
                sn_start_local: [this.requiredRule('请输入产品代码位于SN起始位置')],
                sn_end_local: [this.requiredRule('请输入产品代码位于SN结束位置')],
            }
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.api.ptGetWeightSetting({}).then(data => {
                this.listData = data.data;
            })
        },
        addDislogShow() {
            this.dialog = {
                title: '新增产品配置',
                type: 'add'
            };
            this.actData = {};
            this.$refs.weightSetting.show = true;
        },
        updateDislogShow(item) {
            this.dialog = {
                title: '修改产品配置',
                type: 'update'
            };
            this.actData = {...item};
            delete this.actData.create_time;
            delete this.actData.update_time;
            this.$refs.weightSetting.show = true;
        },
        settingConfirm() {
            this.$refs.addProductRule.validate(v => {
                if(v) {
                    this.actData.min_weight = parseFloat(this.actData.min_weight);
                    this.actData.max_weight = parseFloat(this.actData.max_weight);
                    this.actData.sn_start_local = parseInt(this.actData.sn_start_local);
                    this.actData.sn_end_local = parseInt(this.actData.sn_end_local);
                    this.api.ptWeightSetting(this.actData).then(data => {
                        this.actData = {};
                        this.$refs.weightSetting.show = false;
                        this.getList();
                    })
                }
            })
            
        }
    }
})
</script>
<style lang="less" scoped>
    
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/weight/setting.vue